import moment from "moment";
import essApi from "../axios/essApi";
import { headers } from "../common/axiosUtil";


class LeaveService {

    async getAllLeaves(param = {}) {
        const queryParams = Object.keys(param).map(key => key + '=' + param[key]).join('&');
        return Promise.resolve(essApi.get(`leaves${queryParams && '?' + queryParams}`));
    }
    async getAllMonthLeaves(date = moment(new Date()).format('YYYY-MM-DD')) {
        return Promise.resolve(essApi.get(`leaves?date=${date}`));
    }
    async getAllYearLeaves(date = moment(new Date()).format('YYYY-MM-DD'), status = 0) {
        return Promise.resolve(essApi.get(`leaves?status=${status}&date=${date}&yearWise=true`));
    }
    async deleteLeaveById(id) {
        return Promise.resolve(essApi.delete(`leaves/${id}`));
    }
    async createLeave(reqBody) {
        return Promise.resolve(essApi.post(`leaves`, reqBody));
    }
    async updateLeaveById(payload) {
        return Promise.resolve(essApi.put(`updateLeaveById`, payload));
    }
    async updateDraftLeaveById(payload) {
        return Promise.resolve(essApi.put(`updateUserDraftLeaveById`, payload));
    }
    async updateLeavesData(id, param) {
        return Promise.resolve(essApi.put(`leaves/${id}`, param));
    }
    async deleteAllLeaves(reqBody) {
        return Promise.resolve(essApi.post(`deleteleaves`, reqBody));
    }
    async getAllLeaveByUserId(param) {
        const queryParams = Object.keys(param).map(key => key + '=' + param[key]).join('&');
        return Promise.resolve(essApi.get(`leavesByuserId/${param.id}${queryParams && '?' + queryParams}`));
        // return Promise.resolve(essApi.get(`leavesByuserId/${param.id}`))
    }
    async approveRejectLeave(param) {
        // console.log(param, "paramparam")
        return Promise.resolve(
            essApi.put(`manager-Leaves-approve-and-reject-in-bulk`, param)
        );
    }


    //get leaves by user
    async getLeavesByUser(id) {
        return Promise.resolve(essApi.get(`leave-by-user/${id}`));
    }

    //save leaves by user
    async saveLeavesByUser(leaveArray = []) {
        return Promise.resolve(essApi.post(`leave-by-user-bulk`, leaveArray));
    }

    //update user leave balance by userid
    async updateUserLeaveBalance(payload) {
        return Promise.resolve(essApi.put(`update-leave-balance`, payload));
    }

    //get all leave absence code by user
    async getAllLeaveAbsenceCode() {
        return Promise.resolve(
            essApi.get(`leaveAbsenceCodebyUser`)
        );
    }

    //get all leave absence code by user-location
    async getAbsenceCodesByUserLocation() {
        return Promise.resolve(essApi.get(`absenceCodes-by-userLocation`));
    }

    //submit leaves for review
    async updateMultipleLeave(payload) {
        return Promise.resolve(essApi.put(`updateMultipleLeaves`, payload));
    }

    //get all leave type location wise
    async getLeaveTypesByUserLocation() {
        return Promise.resolve(essApi.get(`leaveType-locationWise`));
    }

    //leave count
    async getLeaveCount() {
        return Promise.resolve(essApi.get(`leave-count`));
    }

    //send leave from review to draft
    async recallReviewLeave(reqBody) {
        return Promise.resolve(essApi.post(`leave-recall`, reqBody));
    }

    //recall approved leave- moved to action
    async recallApprovedLeave(reqBody) {
        return Promise.resolve(essApi.post(`approved_leave_recall`, reqBody));
    }


    //get all employee leaves for manager
    async getEmployeeLeavesBySuperior() {
        return Promise.resolve(essApi.get(`user-leave`));
    }

    //get all employee leaves for manager
    async getTeamLeavesByManager(date = null, op = 'Y') {
        return Promise.resolve(essApi.get(`team-leaves?date=${date}&yearWise=${op}`));
    }

    //get in review leaves for manager
    async getReviewLeavesForSuperior() {
        return Promise.resolve(essApi.get(`user-leave-in-review`));
    }

    //get approved leaves by user
    async getApprovedLeaves(id) {
        return Promise.resolve(essApi.get(`all-recalled-leaves/${id}`));
    }

    /*manager section start*/
    //approve reject review leave in bulk
    async approveRejectLeaveByManager(param) {
        return Promise.resolve(essApi.put(`manager-Leaves-approve-and-reject-in-bulk`, param));
    }
    //approve reject recall review leave in bulk
    async approveRejectRecallLeave(param) {
        return Promise.resolve(essApi.put(`approve-reject-recalled-leave`, param));
    }

    async GetUserLeavesBySuperiorcount(date) {
        return Promise.resolve(essApi.get(`leaves-dashboard?date=${date}`));
    }

    async getLeavesAbsenceBySuperiorcount(date) {
        return Promise.resolve(essApi.get(`leaves-absencecode?date=${date}`));
    }

    //get review recalled leaves
    async getReviewRecallLeaves(id) {
        return Promise.resolve(essApi.get(`review-recalled-leaves/${id}`));
    }
    // Dashboard API 
    async GetUserAbsenceCodeBySuperior() {
        return Promise.resolve(essApi.get(`leaves-absencecode`));
    }
    //get holidays of user 
    async getAllHolidays() {
        return Promise.resolve(essApi.get(`holidays-for-leave`));
    }

    async getAllHolidaysCalander() {
        return Promise.resolve(essApi.get(`leave-holiday-calendar`));
    }

    async GetUserBirthdayAndAnnviversaryBySuperior(date, yearWise = 'N') {
        return Promise.resolve(essApi.get(`birthday-anniversary?yearWise=${yearWise}&date=${date}`));
    }
    async GetUserleavesDetailsOnSameDay() {
        return Promise.resolve(essApi.get(`user-leaves-sameday`));
    }

    async uploadAttachment(formdata) {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'filetype': 'leave'
            }
        };
        return Promise.resolve(essApi.post(`uploadFile`, formdata, config));
    }
}


export default LeaveService;